import instance from "@services/services";
import { ResponseType } from "../../../Types/ServicesType/servicesType";
import { MasterDataType, MasterTableDataType, SaveResponseType, SearchParamsType } from "./types";
import api from "@services/apiList";
const {MastersApi} = api
export const getMastersTableData = async (payload:SearchParamsType & {clinicId:number}):Promise<ResponseType<MasterTableDataType[]>>=>{
    const result = await instance.post(`${MastersApi.getSubDepartments}`,payload);
    return result.data;
}


export const saveMasterData = async (params:MasterDataType):Promise<ResponseType<SaveResponseType>>=>{
    console.log(params)
    const result = await instance.post(`${MastersApi.saveSubDepartments}`,params);
    return result.data;
}

